import firebase from "firebase";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyDs-x8MHeP7mys2oOdZaI8akLbtLqngLkA",
  authDomain: "tenjisugi-1733e.firebaseapp.com",
  databaseURL: "https://tenjisugi-1733e.firebaseio.com",
  projectId: "tenjisugi-1733e",
  storageBucket: "tenjisugi-1733e.appspot.com",
  messagingSenderId: "597069645835",
  appId: "1:597069645835:web:afcb0fe09b93f954709f0e",
  measurementId: "G-Y1QL1KV2Z3",
};

// const firebaseApp = Firebase.initializeApp(config)
// const firestore = firebaseApp.firestore()

// export default firestore

firebase.initializeApp(config);
firebase.analytics();
// export default firebase.firestore();
// export const storage = firebase.storage();
// export default firebase;

export default firebase.firestore();
export const storage = firebase.storage();
export const functions = firebase.functions();
